import { AutoTriggerConfig } from "lib/types/popup";
import { dialogDisplayConfig } from "lib/types/merchantConfigTypes";

export const DEFAULT_AUTO_TRIGGER_CONFIG = [
  { key: "OOS", enabled: true, weight: 40, interruptable: false },
  { key: "ADDRESS_NEW", enabled: true, weight: -10, interruptable: true },
  { key: "ADDRESS_EDIT", enabled: true, weight: -20, interruptable: true },
  { key: "ADDRESS_LIST", enabled: true, weight: -40, interruptable: true },
  { key: "SHIPPING_HANDLES", enabled: true, weight: 50, interruptable: false },
  {
    key: "DISCOUNTED_PRODUCT_SELECTOR",
    enabled: true,
    weight: 30,
    interruptable: false,
  },
  {
    key: "CELEBRATION",
    enabled: true,
    weight: 20,
    interruptable: false,
    delay: 500,
    duration: 3000,
  },
  {
    key: "DELHIVERY_CONFIRMATION",
    enabled: false,
    weight: 10,
    interruptable: false,
    duration: 3000,
  },
] as const satisfies readonly AutoTriggerConfig[];

export type AutoPopupKey = (typeof DEFAULT_AUTO_TRIGGER_CONFIG)[number]["key"];

export const AUTO_TRIGGER_CONFIG_BY_KEY = DEFAULT_AUTO_TRIGGER_CONFIG.reduce(
  (acc, config) => {
    acc[config.key] = config as AutoTriggerConfig;
    return acc;
  },
  {} as Record<AutoPopupKey, AutoTriggerConfig>,
);

export function resolveAutoTriggerConfig(
  remoteDialogs?: dialogDisplayConfig[],
): Record<AutoPopupKey, AutoTriggerConfig> {
  const remoteByKey = new Map((remoteDialogs ?? []).map((dialog) => [dialog.key, dialog]));

  return DEFAULT_AUTO_TRIGGER_CONFIG.reduce(
    (acc, defaultConfig) => {
      const remote = remoteByKey.get(defaultConfig.key);
      acc[defaultConfig.key] = remote
        ? ({
            ...remote,
            key: defaultConfig.key,
            duration: Math.max(remote.duration ?? 0, 2000),
            delay: Math.max(remote.delay ?? 0, 0),
            interruptable: false,
          } as AutoTriggerConfig)
        : (defaultConfig as AutoTriggerConfig);
      return acc;
    },
    {} as Record<AutoPopupKey, AutoTriggerConfig>,
  );
}